<template>
  <div id="app">
    <div class="topnav" id="myTopnav" v-if="showData.access.length">
      <button v-if="showData.access.length" class="openbtn" @click="openNav()">☰</button>
      <!-- <LoginHeader></LoginHeader> -->
      <!-- <a>
        <select class="form-control" v-model="selectedMode" @change="mode">
          <option value="Dev" selected>Dev</option>
          <option value="prod">Prod</option>
        </select>
      </a>
      <a>View Mode :</a>
      <a href="javascript:void(0);" class="icon" onclick="myFunction()">
        <i class="fa fa-bars"></i>
      </a>-->
    </div>
    <div id="mySidebar" class="sidebar">
      <a href="javascript:void(0)" class="closebtn" @click="closeNav()">×</a>
      <a
        href="javascript:void(0)"
        @click="closeNav(), promocode(access)"
        v-for="(access, index) in showData.access"
        :key="index"
        :class="{ active: isCurrentPage(access.path) }"
      >
        <div class="sidebar-item">{{ access.pagename }}</div>
      </a>
      <a href="javascript:void(0)" @click="closeNav()">
        <div class="sidebar-item" v-on:click="logout()">Logout</div>
      </a>
    </div>
    <div>
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import LoginHeader from "@/components/login";

export default {
  name: "app",
  components: {
    // tabulardata
    LoginHeader
  },
  data() {
    return {
      selectedMode: "Dev",
      access: ""
    };
  },
  computed: {
    ...mapGetters({
      showData: "showData"
    }),
    pageNumber: {
      set: function(val) {
        this.$store.commit("updatePageNumber", val);
      },
      get: function() {
        return this.showData.pageNumber;
      }
    }
  },
  created() {
    this.userAccess();
    this.modeSet(); //call api getUserData
    if (this.$route.path === "/") {
      this.currentTab({ tab: "login" });
    }
    if (this.$route.path === "/promocode") {
      this.currentTab({ tab: "promocode" });
    }
    if (this.$route.path === "/proUser") {
      this.currentTab({ tab: "proUser" });
    }
    if (this.$route.path === "/certificates") {
      this.currentTab({ tab: "certificates" });
    }
    if (this.$route.path === "/resetPassword") {
      this.currentTab({ tab: "resetPassword" });
    }
    if (this.$route.path === "/helpDesk") {
      this.currentTab({ tab: "helpDesk" });
    }
    if (this.$route.path === "/addUser") {
      this.currentTab({ tab: "addUser" });
    }
    if (this.$route.path === "/login") {
      this.currentTab({ tab: "login" });
    }
    if (this.$route.path === "/delUser") {
      this.currentTab({ tab: "delUser" });
    }
    if (this.$route.path === "/proCourseUser") {
      this.currentTab({ tab: "proCourseUser" });
    }
    if (this.$route.path === "/hackerxProUser") {
      this.currentTab({ tab: "hackerxProUser" });
    }
    if (this.$route.path === "/pythonxProUser") {
      this.currentTab({ tab: "pythonxProUser" });
    }
    if (this.$route.path === "/offer") {
      this.currentTab({ tab: "offer" });
    }
    // else {
    //   this.currentTab({ tab: "proUser" });
    // }
  },
  methods: {
    ...mapActions([
      "getUserData",
      "setMode",
      "currentTab",
      "updateAccess_",
      "clearAccess",
      "updateLoaderStatus"
    ]),
    closeNav: function() {
      if (document.getElementById("mySidebar")) {
        document.getElementById("mySidebar").style.width = "0";
      }
      if (document.getElementById("main")) {
        document.getElementById("main").style.marginLeft = "0";
      }
    },
    userAccess: function() {
      if (localStorage.getItem("storedAccess")) {
        this.updateAccess_({
          access: JSON.parse(localStorage.getItem("storedAccess"))
        });
      }
    },
    openNav: function() {
      if (document.getElementById("mySidebar")) {
        document.getElementById("mySidebar").style.width = "250px";
      }
      if (document.getElementById("main")) {
        document.getElementById("main").style.marginLeft = "250px";
      }
    },
    promocode: function(val) {
      if (val.pagename == "Promocode") {
        if(this.isCurrentPage(val.path)) return;
        this.currentTab({ tab: "promocode" });
        this.$router.push("/promocode");
      }
      if (val.pagename == "Pro User") {
        if(this.isCurrentPage(val.path)) return;
        this.currentTab({ tab: "proUser" });
        this.$router.push("/proUser");
      }
      if (val.pagename == "Certificates") {
        if(this.isCurrentPage(val.path)) return;
        this.currentTab({ tab: "certificates" });
        this.$router.push("/certificates");
      }
      if (val.pagename == "Reset Password") {
        if(this.isCurrentPage(val.path)) return;
        this.currentTab({ tab: "resetPassword" });
        this.$router.push("/resetPassword");
      }
      if (val.pagename == "Help Desk") {
        if(this.isCurrentPage(val.path)) return;
        this.currentTab({ tab: "helpDesk" });
        this.$router.push("/helpDesk");
      }
      if (val.pagename == "Add User") {
        if(this.isCurrentPage(val.path)) return;
        this.currentTab({ tab: "addUser" });
        this.$router.push("/addUser");
      }
      if (val.pagename == "Del User") {
        if(this.isCurrentPage(val.path)) return;
        this.currentTab({ tab: "delUser" });
        this.$router.push("/delUser");
      }
      if (val.pagename == "Pro Course User") {
        if(this.isCurrentPage(val.path)) return;
        this.currentTab({ tab: "proCourseUser" });
        this.$router.push("/proCourseUser");
      }
      if (val.pagename == "HackerX Pro User") {
        if(this.isCurrentPage(val.path)) return;
        this.currentTab({ tab: "hackerxProUser" });
        this.$router.push("/hackerxProUser");
      }
      if (val.pagename == "PythonX Pro User") {
        if(this.isCurrentPage(val.path)) return;
        this.currentTab({ tab: "pythonxProUser" });
        this.$router.push("/pythonxProUser");
      }
      if (val.pagename == "Offer") {
        if(this.isCurrentPage(val.path)) return;
        this.currentTab({ tab: "offer" });
        this.$router.push("/offer");
      }
    },
    // proUser: function() {
    //   this.currentTab({ tab: "proUser" });
    //   this.$router.push("/proUser");
    // },
    // certificates: function() {
    //   this.currentTab({ tab: "certificates" });
    //   this.$router.push("/certificates");
    // },
    // resetPassword: function() {
    //   this.currentTab({ tab: "resetPassword" });
    //   this.$router.push("/resetPassword");
    // },
    // helpDesk: function() {
    //   this.currentTab({ tab: "helpDesk" });
    //   this.$router.push("/helpDesk");
    // },
    addUser: function() {
      this.currentTab({ tab: "addUser" });
      this.$router.push("/addUser");
    },
    mode: function() {
      this.getUserData({
        mode: this.selectedMode
      });
      this.pageNumber = 0;
    },
    modeSet: function() {
      if (localStorage.getItem("Mode")) {
        var whichMode = localStorage.getItem("Mode");
      } else {
        var whichMode = this.selectedMode;
      }
      this.setMode({ mode: whichMode });
    },
    logout: function(val) {
      localStorage.removeItem("storedData");
      localStorage.removeItem("Mode");
      localStorage.removeItem("storedAccess");
      this.$store.commit("setMode", {
        mode: "Dev"
      });
      this.$router.push("/");
      this.updateLoaderStatus({
        value: false
      });
      this.currentTab({ tab: "/" });
      this.clearAccess();
    },

    isCurrentPage(path){
      return this.$route.path === path
    }
  }
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  /* margin-top: 60px; */
}

.sidebar {
  height: 100%;
  width: 0;
  position: fixed;
  z-index: 1;
  top: 0;
  left: 0;
  background-color: #111;
  overflow-x: hidden;
  transition: 0.5s;
  padding-top: 50px;
}

.sidebar a {
  padding: 1px;
  text-decoration: none;
  font-size: 25px;
  color: #818181;
  display: block;
  transition: 0.3s;
}

.sidebar a:hover {
  color: #f1f1f1;
}

.sidebar .closebtn {
  position: absolute;
  top: 0;
  right: 10px;
  font-size: 30px;
  margin-left: 50px;
}

.sidebar-item {
  padding: 8px 0px;
}

.openbtn {
  font-size: 34px;
  cursor: pointer;
  background-color: #111;
  color: white;
  /* padding: 10px 15px; */
  border: none;
  float: left;
  top: 0;
}

.openbtn:hover {
  background-color: #444;
}

#main {
  transition: margin-left 0.5s;
  padding: 16px;
  float: left;
  top: 0;
}

/* On smaller screens, where height is less than 450px, change the style of the sidenav (less padding and a smaller font size) */
@media screen and (max-height: 450px) {
  .sidebar {
    padding-top: 15px;
  }
  .sidebar a {
    font-size: 18px;
  }
}
/* top nav bar */
.topnav {
  overflow: hidden;
  background-color: #333;
  height: 50px;
  width: auto;
}

.topnav a {
  float: right;
  display: block;
  color: #f2f2f2;
  text-align: center;
  padding: 7px 10px;
  text-decoration: none;
  font-size: 17px;
}

/* .topnav a:hover {
  background-color: #ddd;
  color: black;
}  */

.active {
  background-color: #4caf50;
  color: white;
}

.topnav .icon {
  display: none;
}

@media screen and (max-width: 600px) {
  .topnav a:not(:first-child) {
    display: none;
  }
  .topnav a.icon {
    float: right;
    display: block;
  }
}

@media screen and (max-width: 600px) {
  .topnav.responsive {
    position: relative;
  }
  .topnav.responsive .icon {
    position: absolute;
    right: 0;
    top: 0;
  }
  .topnav.responsive a {
    float: none;
    display: block;
    text-align: left;
  }
}
</style>
